import { isMobile } from '../../../Assets/configuration/index.js';

// Feature detect :focus-visible support
const supportsFocusVisible = (() => {
  try {
    return document.createElement('div').matches(':focus-visible');
  } catch {
    return false;
  }
})();

// Remove --nojs class if JS is active
for (const input of document.querySelectorAll('.--nojs')) {
  input.classList.remove('--nojs');
}

if (!isMobile) {
  document.querySelector('.js-form-submit')?.remove();
}

// FOR SUBMIT ON INPUT CHANGE
const selector = isMobile ? '.js-autoSubmit' : '.js-autoSubmit, .js-autoSubmit-desktop-only';

const syncCheckedInputsWithUrl = () => {
  const form = document.querySelector('#form-filters');
  if (!form) {
    return;
  }

  const queryParams = new URLSearchParams(globalThis.location.search);
  for (const input of form.querySelectorAll('input[type="checkbox"][name]')) {
    const values = queryParams.getAll(input.name);
    input.checked = values.includes(input.value);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  syncCheckedInputsWithUrl();

  const inputs = document.querySelectorAll(selector);
  for (const input of inputs) {
    input.addEventListener('change', () => {
      if (!document.body.dataset.debug) {
        // Only block auto-submit when :focus-visible is supported AND the input is currently focus-visible AND is a radio
        const isFocusVisible = supportsFocusVisible && input.matches(':focus-visible');
        if (!(isFocusVisible && input.getAttribute('type') === 'radio')) {
          if (typeof input.form?.requestSubmit === 'function') {
            // Déclenche les événements (95% navigateurs)
            input.form.requestSubmit();
          } else if (input.form) {
            // Ne déclenche pas les événements (100% navigateurs)
            input.form.submit();
          }
        }
      }
    });
  }
});

globalThis.addEventListener('popstate', syncCheckedInputsWithUrl);
globalThis.addEventListener('pageshow', syncCheckedInputsWithUrl);
